import { useEffect, useState } from 'react'
import { listRole } from '../../Context/api';
import axios from 'axios';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
import { ToastContainer, toast } from 'react-toastify';
import Spinner from '../Spinner/spinner';
import { useNavigate } from 'react-router-dom';

const RoleList = () => {
    const [roleList, setRoleList] = useState([])
    const adminData = JSON.parse(localStorage.getItem('adminData'));
    const [spinner, setSpinner] = useState(false)
    const navigate=useNavigate()

    useEffect(() => {
        list()
    }, [])
    const list = () => {
        setSpinner(true)
        axios.post(listRole(), {}, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
            if (resp.data.code === statusCodes.ok) {
                setRoleList(resp.data)
                setSpinner(false)
            }
            else {
                setRoleList([])
                setSpinner(false)
            }
        })
            .catch(() => {
                toast.error(commonMessage.networkError)
                setSpinner(false)
            })
    }
    return (
        <section>
            <ToastContainer/>
            <div className="m-t-3 cus-padd cusheight">
                {spinner ? <Spinner /> : null}
                <header>
                    <h2 className='page-tittle'>
                        Role List
                    </h2>
                    <hr />
                </header>
                <button className='btn btn-dark ms-1 float-end mb-2'  onClick={()=>navigate('add-role')}>Add Role</button>
                <table className="table  shadow mt-3">
                    <thead className="table-dark">
                        <tr>
                            <th scope="col">#</th>
                            <th scope="col">Role</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            !roleList.data?.length ? <div className='position-absolute top-10 end-50 mt-5'><h3>No record found</h3></div>
                                :
                                <>
                                    {
                                        roleList?.data?.map((item, index) => {
                                            return <>
                                                <tr>
                                                    <th scope="row">{index + 1}</th>
                                                    <td key={index}>{item.title}</td>
                                                </tr>
                                            </>
                                        })
                                    }
                                </>
                        }
                    </tbody>
                </table>
                <div className='w-100 d-flex justify-content-center'>
                </div>
            </div>
        </section>
    )
}

export default RoleList